import { gettext } from '@eventbrite/i18n';

export const IDENTIFICATION_METHOD_ARS_DNI_FIELD = 'DNI';
export const IDENTIFICATION_METHOD_CI_FIELD = 'CI';
export const IDENTIFICATION_METHOD_LC_FIELD = 'LC';
export const IDENTIFICATION_METHOD_LE_FIELD = 'LE';
export const IDENTIFICATION_METHOD_OTHER_FIELD = 'Otro';

export const IDENTIFICATION_METHOD_ARS_DNI = {
    value: IDENTIFICATION_METHOD_ARS_DNI_FIELD,
    display: gettext('DNI (Argentina)'),
};

export const IDENTIFICATION_METHOD_CI = {
    value: IDENTIFICATION_METHOD_CI_FIELD,
    display: IDENTIFICATION_METHOD_CI_FIELD,
};

export const IDENTIFICATION_METHOD_LC = {
    value: IDENTIFICATION_METHOD_LC_FIELD,
    display: IDENTIFICATION_METHOD_LC_FIELD,
};

export const IDENTIFICATION_METHOD_LE = {
    value: IDENTIFICATION_METHOD_LE_FIELD,
    display: IDENTIFICATION_METHOD_LE_FIELD,
};

export const IDENTIFICATION_METHOD_OTHER = {
    value: IDENTIFICATION_METHOD_OTHER_FIELD,
    display: gettext('Other'),
};

export const ALL_IDENTIFICATION_METHODS_AVAILABLE_FOR_ARS = [
    IDENTIFICATION_METHOD_ARS_DNI,
    IDENTIFICATION_METHOD_CI,
    IDENTIFICATION_METHOD_LC,
    IDENTIFICATION_METHOD_LE,
    IDENTIFICATION_METHOD_OTHER,
];

export const ALL_IDENTIFICATION_METHODS_AVAILABLE_FOR_ARS_VALUES = ALL_IDENTIFICATION_METHODS_AVAILABLE_FOR_ARS.map(
    (m) => m.value,
);
